// extracted by mini-css-extract-plugin
module.exports = {"table-text":"List_table-text__3HhCx","list":"List_list__3Gyj4","hasCredit":"List_hasCredit__3_hM-"};